import React from 'react';
import { FormControl, InputLabel, MenuItem, Typography, Select } from '@mui/material';
import { LocalVideoTrack } from 'twilio-video';
import { makeStyles } from '@mui/styles';
import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext';
import { useVideoInputDevices } from '../deviceHooks/deviceHooks';
import VideoTrack from '../../../VideoTrack/VideoTrack';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  preview: {
    width: '150px',
    margin: '0.5em 0',
  },
});

export default function VideoInputList() {
  const classes = useStyles();
  const videoInputDevices = useVideoInputDevices();
  const {
    room: { localParticipant },
    localTracks,
    getLocalVideoTrack,
  } = useVideoContext();

  const localVideoTrack = localTracks.find((track) => track.kind === 'video') as LocalVideoTrack;
  const localVideoInputDeviceId = localVideoTrack?.mediaStreamTrack.getSettings().deviceId;

  function replaceTrack(newDeviceId: string) {
    localVideoTrack?.stop();
    getLocalVideoTrack({ deviceId: { exact: newDeviceId } })
      .then((newTrack) => {
        if (localVideoTrack) {
          const localTrackPublication = localParticipant?.unpublishTrack(localVideoTrack);
          // TODO: remove when SDK implements this event. See: https://issues.corp.twilio.com/browse/JSDK-2592
          localParticipant?.emit('trackUnpublished', localTrackPublication);
        }

        return localParticipant?.publishTrack(newTrack);
      })
      .catch(() => {
        // Replacing track can fail if media permission is blocked.
      });
  }
  const { t } = useTranslation();

  return (
    <div className="inputSelect">
      {videoInputDevices.length > 1 ? (
        <FormControl fullWidth>
          <InputLabel id="video-input-select-label" shrink>
            {t('select-camera')}
          </InputLabel>
          <Select
            labelId="video-input-select-label"
            label={t('select-camera')}
            onChange={(e) => replaceTrack(e.target.value as string)}
            value={localVideoInputDeviceId || ''}
          >
            {videoInputDevices.map((device) => (
              <MenuItem value={device.deviceId} key={device.deviceId}>
                {device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Typography variant="h6">{t('select-camera')}</Typography>
          <Typography>{localVideoTrack?.mediaStreamTrack.label || t('no-local-video')}</Typography>
        </>
      )}
      {localVideoTrack && (
        <div className={classes.preview}>
          <VideoTrack isLocal track={localVideoTrack} />
        </div>
      )}
    </div>
  );
}
